import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Form, Button, Input } from 'antd';

const { TextArea } = Input;

class SubmitIssueForm extends PureComponent {
  static propTypes = {
    form: PropTypes.object.isRequired,
    initialValues: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
  };

  static defaultProps = {
    initialValues: null,
  };

  handleSubmit = e => {
    e.preventDefault();
    const { form, onSubmit } = this.props;

    form.validateFields((err, values) => {
      if (!err) {
        onSubmit(values);
      }
    });
  };

  render() {
    const { form, initialValues } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Form onSubmit={e => this.handleSubmit(e)}>
        <Form.Item label="Name">
          {getFieldDecorator('name', {
            rules: [{ required: true, message: 'Please enter your name.' }],
            initialValue: initialValues.name,
          })(<Input placeholder="John Doe" />)}
        </Form.Item>
        <Form.Item label="Issue Description">
          {getFieldDecorator('description', {
            rules: [{ required: true, message: 'Please enter description.' }],
            initialValue: initialValues.description,
          })(<TextArea placeholder="Please enter problem description." rows={4} />)}
        </Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          style={{ display: 'block', marginLeft: 'auto', padding: '0 3rem' }}
        >
          Submit
        </Button>
      </Form>
    );
  }
}

const WrappedSubmitIssueForm = Form.create({ name: 'submit_issue' })(SubmitIssueForm);

export default WrappedSubmitIssueForm;
